import { Table as TableToExtend } from '@tiptap/extension-table';
import { NodeType } from '../constants';

export const Table = TableToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: 'table table-vtop table-borders table-zebra w-100'
            },
            style: null
        };
    },
    addCommands() {
        return {
            ...this.parent?.(),
            toggleTableAlignment: (className, tableClassNames) => ({ commands }) => {
                const classNames = tableClassNames.replace(/table-v(top|bot|mid)\s?/, '');
                return commands.updateAttributes(NodeType.TABLE, { class: `${classNames} ${className}` });
            },
            toggleTableClass: (className, tableClassNames) => ({ commands }) => {
                const classNames = tableClassNames.includes(className)
                    ? tableClassNames.split(' ').filter((name) => name !== className).join(' ')
                    : `${tableClassNames} ${className}`;
                return commands.updateAttributes(NodeType.TABLE, { class: classNames });
            }
        };
    }
});
